import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

interface TooltipWrapperProps {
  top: number;
  left: number;
}

export const TooltipWrapper = styled.div<TooltipWrapperProps>`
  position: fixed;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  border: 1px solid #ccc;
  padding: 20px;
  z-index: 1000;
  width: 329px; /* фиксированная ширина */
  word-wrap: break-word;

  border-radius: 16px 16px 16px 0;
  box-shadow: 0px 9px 14.5px 0px rgba(0, 0, 0, 0.06),
    0px 0px 0px 6px rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);

  font-size: 14px;
  font-weight: 500;
  color: rgb(31, 10, 53);


  a {
    color: rgb(114, 82, 220);
    text-decoration: none;
  }
`;
